import { TReduxActions } from '../../types/redux';
import { defaultFilterState, IFilterState } from '../../store/filters/model';
import { EFilterActionTypes } from '../../actions/filter';

export function filterReducer(state: IFilterState = defaultFilterState, action: TReduxActions) {
  if (action.type === EFilterActionTypes.RegionChange) {
    return { ...state, query: { ...state.query, region: action.payload } };
  }

  if (action.type === EFilterActionTypes.ResetFilter) {
    return { ...state, query: { ...defaultFilterState.query, region: action.payload } };
  }

  if (action.type === EFilterActionTypes.DateVariationsChange) {
    return { ...state, dateVariations: [...action.payload] };
  }

  if (action.type === EFilterActionTypes.DateChange) {
    return { ...state, query: { ...state.query, date: action.payload } };
  }

  if (action.type === EFilterActionTypes.RoomsChange) {
    return { ...state, query: { ...state.query, rooms: [...action.payload] } };
  }

  if (action.type === EFilterActionTypes.SquareChange) {
    return { ...state, query: { ...state.query, square: action.payload } };
  }

  if (action.type === EFilterActionTypes.PriceChange) {
    return { ...state, query: { ...state.query, price: action.payload } };
  }

  if (action.type === EFilterActionTypes.DecorationChange) {
    return { ...state, query: { ...state.query, decoration: action.payload } };
  }

  if (action.type === EFilterActionTypes.HandOverChange) {
    return { ...state, query: { ...state.query, handOver: action.payload } };
  }

  return state;
}
